import React, { useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';

import {
  Button,
  Card,
  Input,
  Typography,
  List,
  ListItem,
  ListItemPrefix,
  ListItemSuffix,
  Chip,
  Accordion,
  AccordionHeader,
  AccordionBody,
  IconButton,
  MenuItem,
  Tooltip,
  Select,
  Option,
  progress
} from "@material-tailwind/react";
import {
  PresentationChartBarIcon,
  ShoppingBagIcon,
  MapIcon,
  ClipboardDocumentListIcon,
  UserCircleIcon,
  BeakerIcon,
  ChatBubbleLeftIcon,
  EnvelopeIcon,
  DocumentDuplicateIcon,
  UsersIcon,
  Cog6ToothIcon,
  InboxIcon,
  InboxArrowDownIcon,
  PowerIcon,
  UserIcon,
  BanknotesIcon,
  XMarkIcon,
  ExclamationTriangleIcon,
  WrenchIcon,
  FunnelIcon,
  ArrowTopRightOnSquareIcon
} from "@heroicons/react/24/outline";

import {

} from "@heroicons/react/24/solid";


import { ChevronRightIcon, ChevronDownIcon } from "@heroicons/react/24/outline";

import { FieldCard, FieldCardSmall } from "./ViewFieldCard";
import AgroTechnologyLogo from './agro-small.jpg'
import ClientCard from "./ClientCard";
import ClientsList from "./ClientsList";
import MemberCard from "./CrewCard";
import CrewList from "./CrewList";
import FieldsList from "./FieldsList";
import OffersList from "./OffersList";
import OrdersList from "./OrdersList";
import { showAlert } from "./Alert";
import DocumentsList from "./DocumentsList";
import ChatCard from "./ChatCard";
import FertilizationCard from "./FertilizationCard";
import DoubleFieldCard from "./DoubleFieldCard";
import { FieldCompletionCard } from "./FieldCompletionCard";

import SmsCard from './SmsCard.jsx';
import EmailCard from './EmailCard.jsx';

import { PdfPreview } from "./LabForm";
import ResultsProcessingAdvancedCard from "./ResultsProcessingAdvancedCard";
//import { SMSAPI } from 'smsapi';


import { getClients, getOffers, getOrders, getFields, getFieldsInfo, getVehicles, getDocuments, getCrew, getCrops } from "./AdminTools";
import PasswordChange from "./PasswordChange";
import { geoportalGetFeatureInfo } from "./geoportal";

import { VehiclesUpdater } from "./VehiclesUpdater";
import FertilizationCard1 from "./FertilizationCard1";
import { forEach } from "jszip";




const activeOrders = [
  {
    title: "Moje pole przy drodze",
    description:
      "01.08.2023 Wysłano zlecenie wykonania pomiaru",
  },
  {
    title: "Pole przy lesie",
    description:
      "03.08.2023 Wysłano zlecenie wykonania pomiaru",
  },
];


    const PROGRESS = [
        { id: 25, status: "Technik w drodze na wyznaczone pola", message: "Technik jest w drodze na pola objęte zleceniem " },
        { id: 30, status: "Pobieranie próbek z pola", message: "Technik rozpoczął pobieranie próbek z pola" },
        { id: 35, status: "Pobrano część próbek", message: "Technik zakończył pobieranie próbek w dniu dzisiejszym" },
        { id: 40, status: "Zakończono pobieranie próbek", message: "Zakończono pobieranie próbek z pól objętych zleceniem " },
    ]



export function Sidebar() {
  const [open, setOpen] = React.useState(0);
  const [openClients, setOpenClients] = React.useState(false);
  const [openCrew, setOpenCrew] = React.useState(false);
  const [openFields, setOpenFields] = React.useState(false);
  const [openOrders, setOpenOrders] = React.useState(false);
  const [openOffers, setOpenOffers] = React.useState(false);
  const [openDocuments, setOpenDocuments] = React.useState(false);
  const [openChangePass, setOpenChangePass] = React.useState(false);
  const [openErrorReport, setOpenErrorReport] = React.useState(false);
  const [openResultsAdvancedCard, setOpenResultsAdvancedCard] = React.useState(false);
  const [openFertilizationCard, setOpenFertilizationCard] = React.useState(false);
  const [openDoubleViewCard, setOpenDoubleViewCard] = React.useState(false);
  const [openCompletionCard, setOpenCompletionCard] = React.useState(false);
  const [openSmsCard, setOpenSmsCard] = React.useState(false);
  const [openEmailCard, setOpenEmailCard] = React.useState(false);

  const [openChat, setOpenChat] = React.useState(false);
  const [unreadMessages, setUnreadMessages] = React.useState(0);
  const [chat, setChat] = React.useState([]);

  const [openPdf, setOpenPdf] = React.useState(false);

  const [selectedClient, setSelectedClient] = React.useState(0);
  const [selectedClientName, setSelectedClientName] = React.useState('');
  const [selectedClientCity, setSelectedClientCity] = React.useState('');
  const [trackedOrder, setTrackedOrder] = React.useState();
  const [trackedFeatures, setTrackedFeatures] = React.useState(undefined);
  const [trackedProgress,setTrackedProgress] = useState(0);
  const [trackedStatus,setTrackedStatus] = useState("");
  const [trackedClient,setTrackedClient] = useState();
  /////////data for tracked order
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("MySoil - zlecenie zmieniło status");

  const [gotClickFieldId, setGotClickFieldId] = React.useState(0);

  /*
  const [clients, setClients] = useState(JSON.parse(localStorage.getItem("clients")) || []);
  const [offers, setOffers] = useState(JSON.parse(localStorage.getItem("offers")) || []);
  const [orders, setOrders] = useState(JSON.parse(localStorage.getItem("orders")) || []);
  const [fields, setFields] = useState(JSON.parse(localStorage.getItem("orders")) || []);
  const [vehicles, setVehicles] = useState(JSON.parse(localStorage.getItem("vehicles")) || []);
  const [documents, setDocuments] = useState(JSON.parse(localStorage.getItem("documents")) || []);
  const [session, setSession] = useState(localStorage.getItem("session") || null);
  const [rank, setRank] = useState(localStorage.getItem("rank") || 0);
 */
  const [clients, setClients] = useState([]);
  const [offers, setOffers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [crops, setCrops] = useState([]);
  const [fields, setFields] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [session, setSession] = useState(localStorage.getItem("session") || null);
  const [crew, setCrew] = useState([]);
  const [rank] = useState(localStorage.getItem("rank") || 0);
  const [userid] = useState(localStorage.getItem("userid") || 0);


  const navigate = useNavigate();

  React.useEffect(() => {
    if ((rank == 10) && (session)) {

      getClients(session, setClients);
      getOffers(session, setOffers);
      getOrders(session, collectOrders);
      getFieldsInfo(session, setFields);
      getCrew(session, setCrew);
      //getVehicles(session, updateVehicles);
      getDocuments(session, setDocuments);
      getCrops(session,collectCrops);
      getChat();
    }

    if ((rank == 5) && (session)) {
      getClients(session, setClients);
      getOffers(session, setOffers);
      getOrders(session, collectOrders);
      getFieldsInfo(session, setFields);
      getCrew(session, setCrew);
      //getDocuments(session, setDocuments);
      //getChat();
    }
    addEventListener('trackOrder', quietTrackOrder);
    addEventListener('mapClick', mapClickListener);
    return () => {
      removeEventListener('trackOrder', quietTrackOrder);
      removeEventListener('mapClick', mapClickListener);
    };    

  }, []);


  React.useEffect(() => {
    if ((rank==5) && (trackedProgress>0))
    {
      var mess=PROGRESS.filter(p=>p.id==trackedProgress)[0];
      if ((mess) && (mess.message)) setMessage(mess.message);
    }

  },[trackedProgress])

  React.useEffect(() => {
    console.log("CLIENTS effect");
    console.log(clients);
  },[clients])


  function collectClients(data)
    {
      localStorage.setItem("clients",JSON.stringify)
      setClients(JSON.parse(data));
      var tracked=JSON.parse(localStorage.getItem("trackedOrder")) || null;
    }



  function quietTrackOrder(e)
  {
    if (e.detail.order) { console.log ("Start Tracking Order (Sidebar)"); startTrackingOrder(e.detail.order); }
    if (e.detail.features) { console.log ("Got Tracking Features"); setTrackedFeatures(e.detail.features); }
  }


  function mapClickListener(e)
  {
    if (e.detail.fieldid) 
      {
        setGotClickFieldId(e.detail.fieldid);
        var tracked=JSON.parse(localStorage.getItem("trackedOrder")) || null;
        if (tracked !== null && tracked !== undefined) setOpenCompletionCard(true); 
      }
  }


  function startTrackingOrder(order)
  {
    console.log("sidebar start tracking order");
    console.log(order);
    if (order) {
      console.log("set start tracking");
      setTrackedOrder(order);
      setTrackedProgress(order.progress);

      var stat=TECHPROGRESS.filter(p=>p.id==order.progress)[0];
      
      console.log("stat");
      console.log(stat);
      setTrackedStatus(stat);
      if (stat) 
        {
          setTrackedStatus(stat.status);
        }
      
      var clients=JSON.parse(localStorage.getItem("clients"));
      var client=clients.filter(c=>c.id==order.ownerid)[0];
      if (client) setTrackedClient(client);
      console.log("Client");
      console.log(client);  
      console.log("ownerid");
      console.log(order.ownerid);  
      console.log("clients");
      console.log(clients);  

      localStorage.setItem("trackedOrder", JSON.stringify(order));
    }
  }



  function stopTrackingOrder()
  {
    console.log("STOP tracking order");  
    localStorage.removeItem("trackedOrder");
    setTrackedOrder(null);
    setTrackedFeatures(null);
    setTrackedClient(null);
  }



  function collectOrders(data) {
    if (rank == 10) {
      setOrders(data);
      localStorage.setItem("orders", JSON.stringify(data))
    }

    if (rank == 5) {
    
    var myorders = data.filter(d => d.techid == userid);
    console.log("myorders");
    console.log(myorders);
      if (myorders) {
        setOrders(myorders);
        localStorage.setItem("orders", JSON.stringify(myorders))
      console.log("trackedOrder");
      console.log(trackedOrder);
        
      if (trackedOrder)
      {
        var refreshed=myorders.filter(o=>o.id==trackedOrder.id)[0];
        if (refreshed)          
        {
        console.log("refreshed");
        console.log(refreshed);
        setTrackedOrder(refreshed);
        }
      }
      
      
      
      }



    }
  }



  function collectCrops(data) {
      setCrops(data);
      localStorage.setItem("crops", JSON.stringify(data))
  }


  function getChat() {
    var bodydata = JSON.stringify({ action: 'list', session: session });
    //console.log(bodydata);
    fetch('https://online.mysoil.pl/cgi-bin/chat.py', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: bodydata,
      mode: 'cors'

    })
      .then(res => res.json())
      .then(data => { //console.log("data"); //console.log(data); 
      parseChat(data.chat); })
  }


  function countEntries(contentStr) {
    var content = JSON.parse(contentStr);
    var count = 0;
    //console.log("content");
    //console.log(content);
    if (content.length > 0) {
      var index = content.length - 1;
      //console.log("index");
      //console.log(index);
      while ((index >= 0) && (content[index--].side === "user")) count += 1;
    }
    //console.log("count " + count);
    return count;
  }


  function parseChat(chatdata) {
    //console.log("chatdata");
    //console.log(chatdata);

    var counter = 0;
    if (chatdata.length > 0) {
      chatdata.forEach(entry => {
        if (entry.side == "user") {
          entry.unread = countEntries(entry.content);
          counter += entry.unread;
        }
        else {
          entry.unread = 0; //brak nowych wiadomości dla admina
        }

      })
    }
    ////console.log('counter');
    ////console.log(counter);
    ////console.log('chatdata');
    ////console.log(chatdata);

    setUnreadMessages(counter);
    setChat(chatdata);
  }


  function closeChat() {
    getChat(); //refresh chat
    setOpenChat(false);
  }



  function hideAll() {
    setOpenClients(false);
    setOpenCrew(false);
    setOpenDocuments(false);
    setOpenFields(false);
    setOpenOffers(false);
    setOpenOrders(false);
    setOpenErrorReport(false);
  }


  const handleOpenClients = () => {
    hideAll();
    setOpenClients(openClients === true ? false : true);

    getClients(session, setClients);
  };

  const handleOpenCrew = () => {
    hideAll();
    setOpenCrew(openCrew === true ? false : true);
  };

  const handleOpenDocuments = () => {
    hideAll();
    setOpenDocuments(openDocuments === true ? false : true);
  };

  const handleOpenFields = () => {
    hideAll();
    setOpenFields(openFields === true ? false : true);
  };

  const handleOpenOrders = () => {
    hideAll();
    setOpenOrders(openOrders === true ? false : true);
  };

  const handleOpenOffers = () => {
    hideAll();
    setOpenOffers(openOffers === true ? false : true);
  };

  const handleOpenErrorReport = () => {
    setOpenErrorReport(openErrorReport === true ? false : true);
  };

  const handleOpenChat = () => {
    setOpenChat(openChat === true ? false : true);
  };

  const handleOpenFertilization = () => {
    setOpenFertilizationCard(openFertilizationCard === true ? false : true);
  };

  const handleOpenDoubleView = () => {
    setOpenDoubleViewCard(openDoubleViewCard === true ? false : true);
  };

  const handleOpenCompletionCard = () => {
    setOpenCompletionCard(openCompletionCard === true ? false : true);
  };

  const handleOpenSmsCard = () => {
   
    setOpenSmsCard(openSmsCard === true ? false : true);
  };

  const handleOpenEmailCard = () => {
    setOpenEmailCard(openEmailCard === true ? false : true);
  };


  function handleCompletionCardReturn(refresh)
  {
    setOpenCompletionCard(false);
    if (refresh==true)
    {
      getOrders(session, collectOrders);
    }
  }



  function logout() {
    localStorage.removeItem('session');
    localStorage.removeItem('rank');
    localStorage.removeItem('userid');
    localStorage.removeItem('authenticated');
    localStorage.removeItem('vehicles');
    localStorage.removeItem('clients');
    localStorage.clear();
    navigate('/')
  }


  const handleOnSelectClient = (id) => {
    if (id > 0) {
      var client = clients.filter(c => c.id === Number(id))[0];
      if (client) setSelectedClientName(client.name);
      setSelectedClient(id);
      setOpenClients();
    }
  };

  const unselectClient = () => {
    setSelectedClient(0);
    setOpenFields(false);
    getFields(session, () => void 0, 0);
    getFieldsInfo(session, () => void 0, 0);

    localStorage.removeItem('clientFeaturesOnMap');
  };



  const renderItems = activeOrders.map(({ title, description }) => (
    <a href="#" key={title}>
      <MenuItem>
        <Typography variant="h6" color="blue-gray" className="mb-1">
          {title}
        </Typography>
        <Typography variant="small" color="gray" className="font-normal">
          {description}
        </Typography>
      </MenuItem>
    </a>
  ));


  function MenuItem(props) {
    return (
      <ListItem className="h-12 w-[4.3rem] lg:w-auto" onClick={props.onClick}>
        <ListItemPrefix>
          {props.icon}
        </ListItemPrefix>
        <Typography color="blue-gray" className="mr-auto font-normal lg:visible collapse">
          {props.name}
        </Typography>
        <ChevronRightIcon strokeWidth={2.5} className={`mr-1 h-4 w-4 transition-transform ${props.isOpen === true ? "rotate-180" : ""}`} />
      </ListItem>
    )
  }


  function ClientItem() {
    return (
      <div className='flex flex-col m-0 p-1 gap-1 border border-blue-200 bg-blue-50/50 rounded-md align-center shadow-md mr-2'>
        <div className="flex flex-row align-center rounded-md border border-blue-200 bg-white justify-center">
          <IconButton size="md" variant='text' className='my-auto mx-0' color="blue-gray">
            <UserIcon className='h-[18px] w-[18px] stroke-[2px]' />
          </IconButton>
           <p className='text-sm my-auto mx-0 text-black'>{selectedClientName}</p>
        </div>
        <div className="flex flex-row p-0 gap-1 mt-1 justify-center rounded-md ">
        <Tooltip content="Dodaj wyniki badań">
          <IconButton variant="gradient" color="purple" className="p-0" size="sm" onClick={() => setOpenResultsAdvancedCard(true)} >
            <BeakerIcon className='w-5 h-5' color="white" />
          </IconButton>
        </Tooltip>
        <Tooltip content="Aplikacja nawozów">
          <IconButton variant="gradient" color="blue" size="sm" onClick={handleOpenFertilization} >
            <FunnelIcon className='w-5 h-5 stroke-[2px]' color="white" />
          </IconButton>
        </Tooltip>
        <Tooltip content="Sprawdź wyniki badań">
          <IconButton variant="gradient" color="yellow" size="sm" onClick={handleOpenDoubleView} >
            <ArrowTopRightOnSquareIcon className='w-5 h-5' color="black" />
          </IconButton>
        </Tooltip>

        <Tooltip content="Wyjdź z kontekstu klienta">
          <IconButton size="sm" variant="gradient" className='' color="red" onClick={unselectClient}>
            <XMarkIcon className='w-5 h-5 stroke-[2px] color="white"' />
          </IconButton>
        </Tooltip>
        </div>
      </div>
    )
  }


  
    const TECHPROGRESS = [
        { id: 25, status: "W drodze na pola" },
        { id: 30, status: "Pobieranie próbek" },
        { id: 35, status: "Koniec prac na dzisiaj" },
        { id: 40, status: "Zakończono pobieranie próbek" },
    ]


    function updateOrderProgress(e) {
        e.preventDefault();

        
        
        var _status=PROGRESS.filter(p=>p.id == trackedProgress)[0].status;
        if (!_status) _status="";

        let bodydata = JSON.stringify({
            action: "updateprog", session: session, id: trackedOrder.id, fieldid: trackedOrder.fieldid, ownerid: trackedOrder.ownerid, progress: trackedProgress, status: _status
        });
        
        
        fetch('https://online.mysoil.pl/cgi-bin/orders.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'
        })
            .then(res => res.json())
            .then(data => handleUpdateOrderResponse(data))

    }

    function handleUpdateOrderResponse(data) {

        if (data.status === "ok") {
            showAlert("green", data.message, 4000);
            trackedOrder.progress=trackedProgress;
        }
        if (data.status !== "ok") {
            showAlert("red", data.message, 4000);
        }
    }


  function OrderItem() {
    const [notProbed,setNotProbed]=useState(0);
    const [partialyProbed,setPartialyProbed]=useState(0);
    const [fullyProbed,setFullyProbed]=useState(0);


  React.useEffect(() => {
    var counter=[0,0,0];
    var props=JSON.parse(trackedOrder.properties);
    //policzmy pola do przebadania
    var all=JSON.parse(trackedOrder.fieldlist).length;
    props.completion.forEach((comp) => { counter[comp.completion]++ ;});
    setNotProbed(all-counter[1]-counter[2]);
    setPartialyProbed(counter[1]);
    setFullyProbed(counter[2]);

  },[])


    function onSelectProgressChange(e) {
        setTrackedProgress(e);
        let parray = TECHPROGRESS.filter(p => p.id == e);
        if (parray.length == 1) {
            setTrackedStatus(parray[0].status);
            setMessage(parray[0].message);
        }
    }



    return (
      <div className='flex flex-col -ml-1 mr-1 p-1 gap-1 border border-blue-200 bg-blue-50/50 rounded-md align-center shadow-md'>
        <div className="flex flex-row align-center rounded-md border border-blue-200 py-1 bg-white justify-center">
           <p className='text-md my-auto mx-0 text-black'>{"Zlecenie " + trackedOrder.id }</p>
        </div>




        <div className="flex flex-row p-0 gap-1 mt-2 mb-5 justify-center rounded-md ">
        <Tooltip content="Pola, z których nie pobrano próbek">
          <IconButton variant="gradient" color="red" className="p-0" size="sm"  >
            {notProbed}
          </IconButton>
        </Tooltip>
        <Tooltip content="Pola częściowo przebadane">
          <IconButton variant="gradient" color="orange" size="sm"  >
            {partialyProbed}
          </IconButton>
        </Tooltip>
        <Tooltip content="Pola całkowicie przebadane">
          <IconButton variant="gradient" color="green" size="sm"  >
            {fullyProbed}
          </IconButton>
        </Tooltip>

        <Tooltip content="Zakończ śledzenie zlecenia">
          <IconButton size="sm" variant="gradient" className='ml-auto' color="red" onClick={stopTrackingOrder}>
            <XMarkIcon className='w-5 h-5 stroke-[2px] color="white"' />
          </IconButton>
        </Tooltip>
        </div>


             <Select label="Status realizacji zadania" className="shadow-md bg-white text-sm" value={trackedProgress.toString()} onChange={onSelectProgressChange}>
                {TECHPROGRESS.map((value) => (
                      <Option key={value.id} className="text-sm" value={value.id.toString()}>{value.status}</Option>
                ))}
             </Select>


        <div className="flex flex-row px-4 gap-1 mt-2 mb-2 justify-center rounded-md ">
        <Tooltip content="Zaktualizuj status">
          <IconButton variant="gradient" color="blue" className="p-0" size="sm" onClick={updateOrderProgress} >
            <InboxArrowDownIcon className='w-5 h-5 stroke-[2px] color="white"' />
          </IconButton>
        </Tooltip>
        
        <Tooltip content="Wyślij SMS do klienta">
          <IconButton variant="gradient" color="purple" size="sm" className="ml-auto" onClick={handleOpenSmsCard}>
            <ChatBubbleLeftIcon className='w-5 h-5 stroke-[2px] color="white"' />
          </IconButton>
        </Tooltip>

        <Tooltip content="Wyślij email do klienta">
          <IconButton size="sm" variant="gradient" className='ml-0 mr-0' color="purple" onClick={handleOpenEmailCard}>
            <EnvelopeIcon className='w-5 h-5 stroke-[2px] color="white"' />
          </IconButton>
        </Tooltip>
        </div>


      </div>
    )
  }


  /*
    function renderPDF() {
      //ReactPDF.render(<LabFormDocument />, `example.pdf`);
      let stream = ReactPDF.renderToStream(<LabFormDocument />);
      //console.log(stream);
    }
  
  
    async function sendTestSMS() {
      const smsapi = new SMSAPI('SxpBX2HpeqdtPnVd2egpeUFKlo6impbANwNjjA8P');
      
      try {
        const result = await smsapi.sms.sendSms('+48601147951', "Wiadomość żółwiowe źdźbło");
        //console.log(result);
      } catch (err) {
        //console.log(err);
      }
    }
  
  
    function sendTestEmail() {
      var bodydata = JSON.stringify({ action: "sendemail", session: session, address: "irek@internet.szczecin.pl", subject:"test agro-online" , text: "Wiadomość żółwiowe źdźbło", html:"<html>Wiadomość żółwiowe źdźbło</html>" });
  
      //console.log(bodydata);
      fetch('https://online.mysoil.pl/cgi-bin/sms.py', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
        body: bodydata,
        mode: 'cors'
      })
        .then(res => res.json())
        .then(data => //console.log(data))
        .catch(error => {
          //console.log({ errorMessage: error.toString() });
          console.error('There was an error!', error);
      });
    }
  */


  return (
    <>
      <VehiclesUpdater />
      <Card className="h-[calc(100vh-2rem)] w-full max-w-[5rem] lg:max-w-[16rem] p-0 lg:p-4 shadow-xl top-[1rem] left-2 shadow-blue-gray-900/5 z-10 overflow-y-auto overflow-x-hidden">
        <div className="mb-2 p-4 flex mx-auto">
          <img src={AgroTechnologyLogo} alt="Agro-Technology" className="w-14 lg:w-36 flex self-center" />
        </div>
        <List className="w-auto">

          <MenuItem name="Klienci" icon={<UsersIcon className='h-[18px] w-[18px]' />} isOpen={openClients} onClick={handleOpenClients} />
          <MenuItem name="Pola" icon={<MapIcon className='h-[18px] w-[18px]' />} isOpen={openFields} onClick={handleOpenFields} />
          <MenuItem name="Zlecenia" icon={<ClipboardDocumentListIcon className='h-[18px] w-[18px]' />} isOpen={openOrders} onClick={handleOpenOrders} />
          
          {rank == 10 && //admins only
            <>
              <MenuItem name="Dokumenty" icon={<DocumentDuplicateIcon className='h-[18px] w-[18px]' />} isOpen={openDocuments} onClick={handleOpenDocuments} />
              <hr className="my-2 border-blue-gray-50" />
              <MenuItem name="Pracownicy" icon={<UsersIcon className='h-[18px] w-[18px]' />} isOpen={openCrew} onClick={handleOpenCrew} />
              <MenuItem name="Oferta" icon={<BanknotesIcon className='h-[18px] w-[18px]' />} isOpen={openOffers} onClick={handleOpenOffers} />
            </>
          }
          <hr className="my-2 border-blue-gray-50" />

          {rank == 10 && //admins only
          <ListItem className="w-[4.3rem] lg:w-auto disabled" onClick={handleOpenChat}>
            <ListItemPrefix>
              <InboxArrowDownIcon className="h-5 w-5" />
            </ListItemPrefix>
            <span className="lg:visible collapse">Wiadomości</span>
            <ListItemSuffix>
              {unreadMessages > 0 &&
                <Chip size="sm" variant="gradient" className="rounded-full align-center items-center text-sm text-white transition-all mr-0" color={"red"} value={unreadMessages} />
              }
            </ListItemSuffix>
          </ListItem>
          }

          <ListItem className="w-[4.3rem] lg:w-auto" >
            <ListItemPrefix>
              <Cog6ToothIcon className="h-5 w-5" />
            </ListItemPrefix>
            <span className="lg:visible collapse">Ustawienia</span>
          </ListItem>

          <ListItem className="w-[4.3rem] lg:w-auto" onClick={handleOpenErrorReport}>
            <ListItemPrefix>
              <WrenchIcon className="h-5 w-5 text-red-900" />
            </ListItemPrefix>
            <span className="lg:visible collapse text-red-900">Raportuj błąd</span>
          </ListItem>

          <hr className="my-2 border-blue-gray-50" />

          <ListItem color="red" className="w-[4.3rem] lg:w-auto" onClick={logout} >
            <ListItemPrefix>
              <PowerIcon className="h-5 w-5 " color="red" />
            </ListItemPrefix>
            <span className="text-red-500 lg:visible collapse">Wyloguj</span>
          </ListItem>



          {/* SelectedClient */}
          {selectedClient > 0 && (
            <>
              <hr className="mt-8 mb-4 border-blue-gray-200" />
              <ClientItem />
            </>
          )}
          {trackedOrder && (
            <>
              <hr className="mt-8 mb-4 border-blue-gray-200" />
              <OrderItem />
            </>
          )}


        </List>
      </Card>



      {openClients === true ? <ClientsList Close={setOpenClients} onSelect={handleOnSelectClient} /> : ''}
      {openCrew === true ? <CrewList Close={setOpenCrew} /> : ''}
      {openDocuments === true ? <DocumentsList Close={setOpenDocuments} /> : ''}
      {openFields === true ? <FieldsList Close={setOpenFields} clientid={selectedClient} /> : ''}
      {openOffers === true ? <OffersList Close={setOpenOffers} /> : ''}
      {openOrders === true ? <OrdersList Close={setOpenOrders} /> : ''}
      {openDoubleViewCard === true ? <DoubleFieldCard close={() => setOpenDoubleViewCard(false)} fieldid={null} clientid={selectedClient} /> : ''}
      {openResultsAdvancedCard === true ? <ResultsProcessingAdvancedCard Close={setOpenResultsAdvancedCard} clientid={selectedClient} fields={fields} /> : ''}
      {openFertilizationCard === true ? <FertilizationCard Close={setOpenFertilizationCard} clientid={selectedClient} fields={fields} clientname={selectedClientName} /> : ''}
      {openChangePass === true ? <PasswordChange close={setOpenChangePass} /> : ''}
      {openPdf === true ? <PdfPreview close={setOpenPdf} /> : ''}
      {openErrorReport === true ? <EmailCard close={setOpenErrorReport} name="wsparcie techniczne" email="irek@internet.szczecin.pl" subject="Wystąpił błąd w aplikacji" /> : ''}
      {openChat === true ? <ChatCard close={closeChat} side="admin" chat={chat} /> : ''}
      {openCompletionCard === true ? <FieldCompletionCard Close={handleCompletionCardReturn} order={trackedOrder} fieldid={gotClickFieldId} fields={fields} /> : ''}
      {openSmsCard && <SmsCard close={handleOpenSmsCard} name={trackedClient.name} phone={trackedClient.phone} message={message} />}
      {openEmailCard && <EmailCard close={handleOpenEmailCard} name={trackedClient.name} email={trackedClient.email} subject={subject} message={message} />}
      
    </>

  );
};

////Twilio pass: 2EgnA49o%4[(.u{!R@+!OL-/}OT8tsuN
////smsapi pass:  2EgnA49o%4[(.u{!R@+!OL-/}OT8tsuN
///smsapi token : SxpBX2HpeqdtPnVd2egpeUFKlo6impbANwNjjA8P	
